export async function getCost(token) {
  const url =
    "https://kesxkrclz0.execute-api.us-east-1.amazonaws.com/Testing/cost";

  try {
    // console.log("Fetching cost...");

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(
        `Error fetching cost: ${response.status} ${response.statusText}`,
      );
    }

    const data = await response.json();
    // console.log("cost retrieved successfully:", data);
    return data;
  } catch (error) {
    console.error("Failed to fetch cost:", error);
    throw error;
  }
}
